import React from "react";
import {
    Box,
    Container,
    Grid,
    Typography,
    Card,
    CardContent,
    Button,
    useTheme,
    TextField,
} from "@mui/material";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import StarIcon from "@mui/icons-material/Star";
import PeopleIcon from "@mui/icons-material/People";
import PageTransition from "./PageTransition";

const Careers = () => {
    const theme = useTheme();
    const jobListings = [
        {
            title: "FullStack Developer",
            location: "London, UK",
            type: "Full-Time",
            description:
                "We are seeking a talented FullStack Developer, and maintain scalable web applications. You will work on both front-end and back-end components, collaborate with cross-functional teams.",
        },
        {
            title: "Digital Marketing Specialist",
            location: "Manchester, UK",
            type: "Full-Time",
            description:
                "We are seeking a Digital Marketing Specialist to create and execute innovative marketing campaigns across various digital channels.",
        },
        {
            title: "Voice Call Assistant",
            location: "Birmingham, UK",
            type: "Full-Time",
            description:
                "Join our BPO team as a Voice Call Assistant to provide excellent customer support and resolve queries efficiently.",
        }

    ];
    return (
        <Box sx={{
            backgroundColor: "#e6f2ff", py: 5,
        }}>
            <PageTransition>
                <Box
                    sx={{
                        textAlign: "center",
                    }}
                >
                    <Container maxWidth="md">
                        <Typography variant="h4" sx={{ color: theme.palette.secondary.main }} fontWeight="bold" gutterBottom>
                            Join Our Team
                        </Typography>
                        <Typography variant="h6">
                            Be part of a growing company that's shaping the future of technology.
                        </Typography>
                    </Container>
                </Box>

                <Container sx={{ mt: 5 }}>
                    <Typography
                        variant="h5"
                        fontWeight="bold"
                        gutterBottom
                        sx={{ textAlign: "center", color: theme.palette.secondary.main, mb: 4 }}
                    >
                        Why Work With Us
                    </Typography>
                    <Grid container spacing={4}>
                        <Grid item xs={12} md={4}>
                            <Box
                                sx={{
                                    textAlign: "center",
                                    backgroundColor: "#fff",
                                    p: 3,
                                    borderRadius: 2,
                                    boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                                }}
                            >
                                <StarIcon sx={{ fontSize: 50, color: "#FFD700", mb: 2 }} />
                                <Typography variant="h6" fontWeight="bold" gutterBottom>
                                    Growth Opportunities
                                </Typography>
                                <Typography variant="body1">
                                    Advance your career with continuous learning and development.
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Box
                                sx={{
                                    textAlign: "center",
                                    backgroundColor: "#fff",
                                    p: 3,
                                    borderRadius: 2,
                                    boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                                }}
                            >
                                <PeopleIcon sx={{ fontSize: 50, color: "#4A3F94", mb: 2 }} />
                                <Typography variant="h6" fontWeight="bold" gutterBottom>
                                    Collaborative Culture
                                </Typography>
                                <Typography variant="body1">
                                    Work with passionate and innovative teams.
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Box
                                sx={{
                                    textAlign: "center",
                                    backgroundColor: "#fff",
                                    p: 3,
                                    borderRadius: 2,
                                    boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                                }}
                            >
                                <WorkOutlineIcon sx={{ fontSize: 50, color: "#4CAF50", mb: 2 }} />
                                <Typography variant="h6" fontWeight="bold" gutterBottom>
                                    Competitive Benefits
                                </Typography>
                                <Typography variant="body1">
                                    Enjoy perks that support your personal and professional goals.
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>

                <Container sx={{ mt: 6 }}>
                    <Typography
                        variant="h4"
                        fontWeight="bold"
                        gutterBottom
                        sx={{ textAlign: "center", color: theme.palette.secondary.main, mb: 4 }}
                    >
                        Current Job Openings
                    </Typography>
                    <Grid container spacing={4}>
                        {jobListings.map((job, index) => (
                            <Grid item xs={12} md={4} key={index}>
                                <Card
                                    sx={{
                                        boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                                    }}
                                >
                                    <CardContent>
                                        <Typography variant="h6" fontWeight="bold" gutterBottom>
                                            {job.title}
                                        </Typography>
                                        <Typography variant="body1" sx={{ mb: 2 }}>
                                            Location: {job.location}
                                        </Typography>
                                        <Typography variant="body2" sx={{ mb: 3 }}>
                                            {job.description}
                                        </Typography>
                                        <Button
                                            variant="contained"
                                            color="#fffff"
                                            fullWidth
                                            sx={{
                                                backgroundColor: theme.palette.tertiary.main,

                                            }}
                                        >
                                            Apply Now
                                        </Button>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </PageTransition>
        </Box>
    );
};

export default Careers;
